export default {
  featureRestricted: "Cette fonctionnalité nécessite un abonnement",
  pageTitle: "Choisissez votre plan",
  pageDescription: "Sélectionnez le plan qui correspond le mieux à vos besoins",
  
  plan: {
    free: "Gratuit",
    basic: "Basique",
    premium: "Premium",
    pro: "Pro",
    essential: "Essentiel"
  },

  plans: {
    free: "Gratuit",
    essential: "Essentiel",
    pro: "Pro",
    premium: "Premium"
  },
  
  currentPlan: "Plan actuel",
  currentPlanMessage: {
    free: "Vous utilisez le plan Gratuit",
    pro: "Vous êtes membre Premium !"
  },

  eventsUsed: "Événements utilisés",
  mostPopular: "Le plus populaire",
  choosePlan: "Choisir ce plan",
  
  freePrice: "0€",
  essentialPrice: "15€/mois",
  proPrice: "30€/mois",
  
  freeDescription: "Parfait pour commencer",
  essentialDescription: "Pour les mariages classiques",
  proDescription: "Pour les grands événements",
  
  unlimited: "Illimité",
  subscriptionUpdated: "Votre abonnement a été mis à jour avec succès",
  updateError: "Erreur lors de la mise à jour de votre abonnement",
  usingBasicFeatures: "Utilisation des fonctionnalités de base",
  limitReached: "Limite {{limit}} atteinte ({{count}}/{{max}})",
  upgradeToIncreaseLimits: "Mettez à niveau pour augmenter ces limites",
  multipleEventsRestricted: "La gestion de plusieurs événements est limitée",
  upgradeToProForMultipleEvents: "Mettez à niveau vers Pro pour gérer plusieurs événements",
  viewPlans: "Voir les plans",
  upgradeToAccessPlan: "Passez au plan {{plan}} pour accéder à cette fonctionnalité",
  upgradeToAccessFeature: "Passez à un plan supérieur pour accéder à {{feature}}",
  
  features: {
    title: "Fonctionnalités",
    weddingWebsite: "Site web de mariage",
    exportPDF: "Export PDF",
    exportExcel: "Export Excel",
    customDomain: "Domaine personnalisé",
    adsRemoval: "Suppression des publicités",
    guestGroups: "Groupes d'invités",
    seatingPlanner: "Plan de table",
    budgetAnalytics: "Analyses budgétaires",
    aiAssistant: "Assistant IA",
    customFields: "Champs personnalisés",
    prioritySupport: "Support prioritaire"
  },
  
  limits: {
    title: "Limites",
    maxGuests: "Invités maximum",
    maxTasks: "Tâches maximum", 
    maxVendors: "Prestataires maximum",
    maxCollaborators: "Collaborateurs maximum"
  },
  
  faq: {
    title: "Questions fréquentes",
    question1: "Puis-je changer de plan à tout moment ?",
    answer1: "Oui, vous pouvez mettre à niveau ou rétrograder votre plan à tout moment. Les changements prennent effet immédiatement.",
    question2: "Y a-t-il des frais cachés ?",
    answer2: "Non, tous nos prix sont transparents. Aucun frais supplémentaire ne sera facturé.",
    question3: "Puis-je annuler à tout moment ?",
    answer3: "Oui, vous pouvez annuler votre abonnement à tout moment. Vous garderez l'accès jusqu'à la fin de votre période de facturation.",
    question4: "Proposez-vous des réductions pour les étudiants ?",
    answer4: "Oui, nous offrons une réduction de 20% pour les étudiants. Contactez-nous pour plus d'informations.",
    multipleEventsQuestion: "Puis-je gérer plusieurs événements ?",
    multipleEventsAnswer: "Avec le plan Pro, vous pouvez gérer un nombre illimité d'événements. Les plans gratuit et essentiel sont limités à un événement."
  },
  
  billing: {
    monthly: "Mensuel",
    yearly: "Annuel",
    save: "Économisez {{percent}}%"
  },
  
  actions: {
    upgrade: "Mettre à niveau",
    downgrade: "Rétrograder",
    cancel: "Annuler l'abonnement",
    reactivate: "Réactiver l'abonnement"
  },
  
  messages: {
    upgradeSuccess: "Votre plan a été mis à niveau avec succès",
    downgradeSuccess: "Votre plan a été rétrogradé avec succès",
    cancelSuccess: "Votre abonnement a été annulé",
    reactivateSuccess: "Votre abonnement a été réactivé"
  }
,

  pageSubtitleNew: "Adaptez WedBox à vos besoins avec nos plans flexibles",
  refreshBtn: "Actualiser",
  popular: "Populaire",
  current: "Actuel",
  freePlanBtn: "Plan gratuit",
  upgradeTo: "Passer à {{plan}}",
  currentPlanBtn: "Plan actuel",
  usage: {
    events: "Gestion d'événements",
    guests: "Invités",
    tasks: "Tâches",
    vendors: "Prestataires"
  },
  units: {
    events: "événement(s)",
    guests: "invité(s)",
    tasks: "tâche(s)",
    vendors: "prestataire(s)"
  },
  checkout: {
    title: "Paiement sécurisé",
    secureStripe: "Paiement sécurisé avec Stripe",
    cancelAnytime: "Vous pouvez annuler votre abonnement à tout moment depuis votre compte.",
    lastRefresh: "Dernière actualisation:",
    mustBeLoggedIn: "Vous devez être connecté pour procéder au paiement",
    freeNoPayment: "Le plan gratuit ne nécessite pas de paiement",
    creatingSession: "Création de la session de paiement...",
    redirecting: "Redirection vers Stripe...",
    subscribeTo: "S'abonner au plan {{plan}}",
    cancel: "Annuler",
    securePayment: "Paiement sécurisé par Stripe"
  },
  planDetails: {
    free: {
      name: "Gratuit",
      price: "0€",
      description: "Parfait pour commencer",
      features: [
        "Gestion d'un événement",
        "Jusqu'à 50 invités",
        "20 tâches maximum",
        "10 prestataires",
        "Support communautaire"
      ]
    },
    essential: {
      name: "Essential",
      price: "9€",
      description: "Pour les événements importants",
      features: [
        "Gestion de 3 événements",
        "Jusqu'à 200 invités",
        "Tâches illimitées",
        "25 prestataires",
        "Export PDF/Excel",
        "Groupes d'invités",
        "Support prioritaire"
      ]
    },
    pro: {
      name: "Pro",
      price: "19€",
      description: "Solution complète",
      features: [
        "Événements illimités",
        "Invités illimités",
        "Tâches illimitées",
        "Prestataires illimités",
        "Planificateur de tables",
        "Analyses avancées",
        "Rapports personnalisés",
        "Support premium"
      ]
    }
  }

};